export default __webpack_public_path__ + "static/media/sendFileIcon.6096b567.svg";